import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";
import { AngularFireStorage } from "@angular/fire/storage";

@Component({
  selector: "multimedia",
  templateUrl: "./multimedia.component.html",
  styleUrls: ["./multimedia.component.scss"],
})
export class MultimediaComponent implements OnInit {
  @Input() images: any[];
  @Input() panelWidth: number;
  @Input() panelHeight: number;
  @Output() onImageChange = new EventEmitter<any>();
  multimediaArray: any[] = [];
  play: boolean;
  pause: boolean;
  @ViewChild("videoEl") private videoElRef: ElementRef;
  @ViewChild("videoContainerEl")
  private videoContainerElRef: ElementRef;
  constructor(config: NgbCarouselConfig, private storage: AngularFireStorage) {
    config.interval = 0;
  }
  ngOnInit() {
    console.log(this.images);
  }

  slideIndex(event) {
    const index = { index: event.current };
    this.onImageChange.emit(index);
  }

  get video(): HTMLVideoElement {
    return this.videoElRef.nativeElement;
  }

  get videoContainer(): HTMLElement {
    return this.videoElRef.nativeElement;
  }

  onPlay() {
    this.video.play();

    this.buttonTouched("play");
  }

  onPause() {
    this.video.pause();
    this.buttonTouched("pause");
  }

  onFullscreen() {
    if (this.videoContainer.requestFullscreen) {
      this.videoContainer.requestFullscreen();
    } else if ((this.video as any).mozRequestFullScreen) {
      (this.videoContainer as any).mozRequestFullScreen();
    } else if ((this.video as any).webkitRequestFullscreen) {
      (this.videoContainer as any).webkitRequestFullscreen();
    } else if ((this.video as any).msRequestFullscreen) {
      (this.videoContainer as any).msRequestFullscreen();
    }
  }
  buttonTouched(buttonTouched: string) {
    if (buttonTouched === "play") {
      this.play = true;
      this.pause = false;
    } else if (buttonTouched === "pause") {
      this.pause = true;
      this.play = false;
    } else {
      this.pause = false;
      this.play = false;
    }
  }
}
